import React from 'react';
import { useLocation, useRouteMatch } from 'react-router';

import { Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { action } from 'lib/actionHelpers';
import selectors from '../../selectors/selectors.js';
import { useSelector } from 'react-redux';
import getAppHeaderNavLinks from './lib/getAppHeaderNavLinks.js';
import SVG from '../../images/svg/SVG.js';
import inboxFoldersSelector from 'screens/inbox/store/inboxFoldersSelector.js';
import getFolderEventsById from 'lib/getFolderEventsById.js';

export const AppHeaderNav = () => {
  const match = useRouteMatch('/:serviceProviderId');
  const location = useLocation();
  const allPermissions = useSelector(selectors.serviceProviderPermissions);
  const tresioUser = useSelector((state) => state.user.tresioUser);

  const serviceProviderId = useSelector(selectors.serviceProviderId);
  const serviceProviderIdWithFallback = useSelector(selectors.serviceProviderIdWithFallback);
  const fullScreenMode = useSelector((state) => state.video.fullScreenMode);
  const defaultPipelineId = ((useSelector(selectors.serviceProviderPipelines) || [])[0] || {}).id;
  const folderEvents = useSelector(selectors.folderEvents);
  const folders = useSelector(inboxFoldersSelector);
  const visibleFolders = folders.filter((n) => (n.visibility || []).includes('nav'));

  const links = getAppHeaderNavLinks({
    folders: visibleFolders,
    serviceProviderId: serviceProviderIdWithFallback,
    defaultPipelineId,
    params: (match || {}).params,
    location,
    allPermissions,
    tresioUser,
  });

  const acknowledgeEvents = (link) => {
    const matchedEvents = (folderEvents.find((n) => n.id === link.label.toLowerCase()) || {}).events || [];
    const ids = matchedEvents.map((n) => (n.event_data || {}).id).filter((n) => n !== undefined);
    if (ids) {
      action('ACKNOWLEDGE_EVENT_TYPE', {
        type: 'new_message',
        ids,
        serviceProviderId: serviceProviderId,
      });
    }
  };

  const handleLinkClick = (n) => {
    action('uiSetRouteKey', Math.floor(Math.random() * 100000000));
    acknowledgeEvents(n);
  };

  return (
    <Nav className={`header-navigation ${match ? 'is-active' : ''}${fullScreenMode ? ' full-screen-mode' : ''}`}>
      {!!match &&
        links.map((n, i) => (
          <NavLink
            key={i}
            data-title={n.disabled ? 'Permission Not Granted' : n.label}
            onClick={(e) => {
              if (!n.disabled) {
                handleLinkClick(n);
              }
            }}
            className={`header-item header-item__${n.label.toLowerCase()} ${n.active ? 'is-active' : 'is-inactive'} ${n.label} ${n.disabled ? 'disabled' : ''}`}
            exact={true}
            to={n.link}>
            {n.icon && <img src={n.icon} alt={n.label} />}
            {n.svg && <SVG icon={n.svg} />}
            <i className={'count'} />
          </NavLink>
        ))}
    </Nav>
  );
};
